/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Range_Prices_CtaInputs */

const en_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Range Prices`)
};

const es_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precios del campo`)
};

const de_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Range-Preise`)
};

const zh_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`练习场价格`)
};

const ar_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أسعار الميدان`)
};

const fr_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarifs practice`)
};

const vi_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá sân tập`)
};

const sw_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei za uwanja wa mazoezi`)
};

const th_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ราคาสนามไดร์ฟ`)
};

const bs_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cijene vježbališta`)
};

const ja_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レンジ価格`)
};

const ko_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레인지 가격`)
};

const pt_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preços do driving range`)
};

const it_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzi del campo pratica`)
};

const sv_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rangepriser`)
};

const nl_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rangeprijzen`)
};

const da_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rangepriser`)
};

const nb_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rangepriser`)
};

const fi_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinnat`)
};

const pl_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cennik driving range`)
};

const ru_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цены драйвинг-рейнджа`)
};

const tr_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range fiyatları`)
};

const hi_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रेंज मूल्य`)
};

const id_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga driving range`)
};

const ms_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga driving range`)
};

const cs_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceník driving range`)
};

const el_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τιμές driving range`)
};

const he_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחירי מגרש האימונים`)
};

const af_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oefenbaanpryse`)
};

const hu_range_prices_cta = /** @type {(inputs: Range_Prices_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range árak`)
};

/**
* | output |
* | --- |
* | "Range Prices" |
*
* @param {Range_Prices_CtaInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const range_prices_cta = /** @type {((inputs?: Range_Prices_CtaInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Range_Prices_CtaInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_range_prices_cta(inputs)
	if (locale === "de") return de_range_prices_cta(inputs)
	if (locale === "zh") return zh_range_prices_cta(inputs)
	if (locale === "ar") return ar_range_prices_cta(inputs)
	if (locale === "fr") return fr_range_prices_cta(inputs)
	if (locale === "vi") return vi_range_prices_cta(inputs)
	if (locale === "sw") return sw_range_prices_cta(inputs)
	if (locale === "th") return th_range_prices_cta(inputs)
	if (locale === "bs") return bs_range_prices_cta(inputs)
	if (locale === "ja") return ja_range_prices_cta(inputs)
	if (locale === "ko") return ko_range_prices_cta(inputs)
	if (locale === "pt") return pt_range_prices_cta(inputs)
	if (locale === "it") return it_range_prices_cta(inputs)
	if (locale === "sv") return sv_range_prices_cta(inputs)
	if (locale === "nl") return nl_range_prices_cta(inputs)
	if (locale === "da") return da_range_prices_cta(inputs)
	if (locale === "nb") return nb_range_prices_cta(inputs)
	if (locale === "fi") return fi_range_prices_cta(inputs)
	if (locale === "pl") return pl_range_prices_cta(inputs)
	if (locale === "ru") return ru_range_prices_cta(inputs)
	if (locale === "tr") return tr_range_prices_cta(inputs)
	if (locale === "hi") return hi_range_prices_cta(inputs)
	if (locale === "id") return id_range_prices_cta(inputs)
	if (locale === "ms") return ms_range_prices_cta(inputs)
	if (locale === "cs") return cs_range_prices_cta(inputs)
	if (locale === "el") return el_range_prices_cta(inputs)
	if (locale === "he") return he_range_prices_cta(inputs)
	if (locale === "af") return af_range_prices_cta(inputs)
	if (locale === "hu") return hu_range_prices_cta(inputs)
	return en_range_prices_cta(inputs)
});